export const currencyFieldAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isRoundedNumber",
  "isPII",
  "isVisible",
  "isDisabled",
  "isNegative",
  "baseCurrency",
  "separator",
  "decimal",
  "enableFieldRules",
  "writeJavascript",
];

export const checkboxFieldAdvancedData = [
  "isRequired",
  "isVisible",
  "isDisabled",
  "initialValue",
  "isPII",
  "writeJavascript",
];

export const datePickerAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "enableFieldRules",
  "dateFormat",
  "writeJavascript",
  "isPastDateDisabled",
  "fromFieldId",
  "toFieldId",
  "isMonthDisplayRequired",
  "monthDisplayFieldId",
  "isCurrentDateSelected",
  "dateInitialValueType",
  "initialValue",
  "isPartOfTimeSlot",
  // "isWeekendDisabled",
  "dateRangeEnabled",
  "specificDateSelectionEnabled",
  "specificDateRangeEnabled",
  // "jsonApiEnabled",
  "preDisableDateCount",
  "postDisableDateCount",
  "specificDates",
  "specificDateRange",
  // 'dateJsonApiUrl',
];

export const datetimePickerAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "enableFieldRules",
  "writeJavascript",
  "isCurrentDateTimeSelected",
  "dateTimeInitialValueType",
  "initialValue",
];

export const dropDownAdvancedData = [
  "initialValueWithAccessKey",
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "selectedType",
  "sort",
  "dynamicOptionsSetup",
  "options",
  "writeJavascript",
  "toggleInitialValue"
];

export const fileUploadFieldAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "maxNumFiles",
  "maxFileSize",
  "isSpecificFileType",
  "selectedFileTypes",
  "isImageViewEnable",
  "isLogoUpload",
  "imageHeight",
  "imageWidth",
];

export const linearScaleAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "lowerScale",
  "upperScale",
  "lowerScaleLabel",
  "upperScaleLabel",
];

export const multichoiceAdvancedData = [
  "isRequired",
  "isPII",
  "isVisible",
  "isDisabled",
  "options",
  "selectedType",
  "alignDirection",
  "enableFieldRules",
  "writeJavascript",
];

export const ratingFieldAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "upperLimit",
];

export const multiLineAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "writeJavascript",
];

export const singleLineAdvancedData = [
  "initialValueWithAccessKey",
  "isRequired",
  "isDuplicateAllowed",
  "isVisible",
  "isDisabled",
  "showVirtualKeyboard",
  "enableFieldRules",
  "writeJavascript",
  "isPII",
  "maskedField",
];
export const formLinkAdvancedData = [
  "isRequired",
  "isVisible",
  "isEditResponse",
  "formLinkId",
  "addResponseLabel",
  "editResponseLabel",
];
export const yearSelectorAdvancedData = [
  "isRequired",
  "isVisible",
  "isDisabled",
  "isMultipleSelection",
  "noOfVisibleYears",
  "noOfHidingYearsFromCurrentYear",
  "defaultYearVisible",
  "initialValueYearType",
  "initialValueYear",
  "writeJavascript",
];
export const sequenceAdvancedData = [
  "prefix",
  "postfix",
  "sequenceType",
  "numericSequenceCount",
  "defaultSequenceValue",
  "generateSequenceByWorkflow",
  "hideFromVisiblity",
];

export const timePickerAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "isDisabled",
  "fromTimeFieldId",
  "toTimeFieldId",
  "enableFieldRules",
  "writeJavascript",
  "isTimeOfDayRequired",
  "timeOfDayFieldId",
  "timeOfDayConfig",
  "isRegularTimeFormat",
  "isCurrentTimeSelected",
  "timeInitialValueType",
  "initialValue",
];

export const numberInputAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isVisible",
  "isDisabled",
  "isNegativeAllowed",
  "isRoundedNumber",
  "isDecimal",
  "maxNumberAllowed",
  "minNumberAllowed",
  "fromNumberFieldId",
  "toNumberFieldId",
  "initialValueWithAccessKey",
  "decimal",
  "enableFieldRules",
  "writeJavascript",
  "maskedField",
  "isIncrDecrEnabled",
  "incrDecrType",
  "isSubmissionCount",
  "submissionCountForm",
  "lookupFilter",
];
export const pincodeAdvancedData = [
  "isRequired",
  "isAutoFetch",
  "country",
  "state",
  "district",
  "placename",
  "taluk",
];

export const lookupFieldAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isDisabled",
  "referenceLookUp",
  "initialValueWithAccessKey",
  "sourceForm",
  "sourceField",
  "selectionType",
  "displayType",
  "sortBy",
  "inclusion",
  "isDataGridDuplicateDisabled",
  "isDataGridLookUpDuplicateDisabledByRows",
  "dataGridLookupDuplicateDisabledRowByField",
  "showAddSubmission",
  "isRefrenceToCurrentForm",
  "enableMappingInEditMode",
  "isPreSelectedValueRequired",
  "filters",
  "lookupFilter",
  "writeJavascript",
  "isApiTriggerOnClick",
];

export const tableFieldAdvancedData = [
  "isRequired",
  "isPII",
  "isVisible",
  "isDisabled",
  "writeJavascript",
  "canAdd",
  "canDelete",
  "minRow",
  "maxRow",
  "defaultHeight",
  "rowCount",
];

export const timeSlotAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isVisible",
  "isDisabled",
  "slotDuration",
  "slotSetting",
  "dateReferralFieldId",
];

export const buttonAdvancedData = [
  "buttonStyles",
  "buttonText",
  "backgroundEffect",
  "backgroundStroke",
  "buttonAction",
];
export const bannerAdvancedData = [
  "bannerTabValue"
];

export const geoLocationFieldAdvancedData = [
  "isRequired",
  "geolocationType",
  "locationInputPermission",
  "locationPlaceHolder",
];

export const signatureFieldAdvancedData = [
  "isDuplicateAllowed",
  "isPII",
  "signatureType",
  "canvasHeight",
  "canvasColor",
  "manualSignature",
  "eSign",
];

export const doublePanelAdvancedData = [
  "leftPanelConfiguration",
  "rightPanelConfiguration",
  "isShowCountEnabled",
];

export const captchaAdvancedData = [
  "isRequired",
  "isDuplicateAllowed",
  "isPII",
  "isVisible",
  "captchadropdownOptions",
  "captchaResetTime",
  "captchabgColor",
  "errorMessage",

];
export const linkedDropdownAdvancedData = [
  "isRequired",
  "isVisible",
  "isDisabled",
  "linkedValues"
];
export const descriptionRichTextAdvancedData = [
  "isRequired",
  "isVisible",
  "isDisabled",
  "description",
  "descriptionType",
  "isRichTextEnable",
  "descriptionFieldHeight"
];
